


















































































import {
  defineComponent, computed, PropType,
} from '@vue/composition-api';
import type { RightSummaryType } from '@/api/rights/types';
import {
  rightsDescriptionEnum,
  rightsPriceTextEnum,
  rightsServiceMapping,
} from '../rightsServiceMapping';
import SelfZhenxiangCard from '../newRightsDescriptionCompoments/self-zhenxiang-card';
import ChannelZhenxiangCard from '../newRightsDescriptionCompoments/channel-rights-card';
import ZhenxiangMemberCard from '../newRightsDescriptionCompoments/zhenxiang-member-card';

interface Props {
  rightSummary: RightSummaryType;
  isRightDiscountUser: boolean;
}

export default defineComponent({
  name: 'RightsCardContent',
  components: {
    SelfZhenxiangCard,
    ChannelZhenxiangCard,
    ZhenxiangMemberCard,
  },
  props: {
    rightSummary: {
      type: Object as PropType<RightSummaryType>,
      required: true,
    },
    isRightDiscountUser: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['tabChange', 'showRightsDetail'],
  setup(props: Props, { emit }: { emit: (event: string, ...args: unknown[]) => void }) {
    /** 获取当前权益服务文案 */
    const currentRightsServiceText = computed(
      () => rightsServiceMapping.getRightsServiceText(props.rightSummary),
    );

    /** 是否为臻享会员卡 */
    const isZhenxiangMemberCard = computed(
      () => currentRightsServiceText.value.rightsPriceText
        === rightsPriceTextEnum.ZHENXIANG_MEMBER_CARD,
    );

    /** 价格文本组件是否显示 */
    const priceTextComponent = computed(
      () => currentRightsServiceText.value.rightsPriceText
        === rightsPriceTextEnum.ZHENXIANG_MEMBER_CARD
        || currentRightsServiceText.value.rightsPriceText
        === rightsPriceTextEnum.ZHENXIANG_CARD,
    );

    /** 描述组件 */
    const descriptionComponent = computed(() => {
      if (currentRightsServiceText.value.rightsDescription
        === rightsDescriptionEnum.SELF_ZHENXIANG_CARD) {
        return SelfZhenxiangCard;
      }
      if (currentRightsServiceText.value.rightsDescription
        === rightsDescriptionEnum.CHANNEL_ZHENXIANG_CARD) {
        return ChannelZhenxiangCard;
      }
      if (currentRightsServiceText.value.rightsDescription
        === rightsDescriptionEnum.ZHENXIANG_MEMBER_CARD) {
        return ZhenxiangMemberCard;
      }
      return null;
    });

    /** 处理 tab 切换 */
    const handleTabChange = () => {
      emit('tabChange');
    };

    /** 处理显示权益详情 */
    const handleShowRightsDetail = () => {
      emit('showRightsDetail', props.rightSummary);
    };

    return {
      currentRightsServiceText,
      isZhenxiangMemberCard,
      priceTextComponent,
      descriptionComponent,
      handleTabChange,
      handleShowRightsDetail,
    };
  },
});
